import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import { createReservation } from '../models/reservation';
import { getLocations, getSchedule } from '../models/setting';
import { Alert, UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import Moment from 'react-moment';

import Button from './button';

class FridayLocation extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      locations: null,
      selectedLocation: null,
      fridayName: (this.props.reservation&&this.props.reservation.fridayName)||'',
      fridayDate: null,
      fridayDatesAvailable: null,
      isLoadedSchedule: false,
      error: null
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.retrieveLocations();
    this.retrieveSchedule();
  }

  retrieveLocations() {
    const { reservation } = this.props;
    getLocations().then(
      (result) => {
        let selectedLocation = null;
        if(reservation&&reservation.fridayLocationId){
          selectedLocation = result.find(loc=>loc.id===reservation.fridayLocationId);
        }
        this.setState({
          locations: result,
          selectedLocation     
        });
      },
      (error) => {
        this.setState({ error });
      }
    );
  }

  retrieveSchedule() {
    const { reservation } = this.props;
    getSchedule()
      .then(result => {
        let schedule = result;
        let fridayDate = null;
         if(reservation&&reservation.fridayDate){
          fridayDate = schedule.find(day=>day.date===reservation.fridayDate);
        }
        const fridayDatesAvailable = [];
        for (const day of schedule) {
          if (!day.shabbosMode) break;
          fridayDatesAvailable.push(day);
        }
        this.setState({
          fridayDate,
          fridayDatesAvailable,
          isLoadedSchedule: true
        })
      }, error => {
        this.setState({error});
      });
  }

  handleSubmit(e) {
    e.preventDefault();
    const {fridayName, selectedLocation, fridayDatesAvailable, fridayDate} = this.state;
    if(fridayName && selectedLocation && ((fridayDatesAvailable.length>1&&fridayDate)||fridayDatesAvailable.length===1)){
      let res = this.props.reservation||{};
      res.fridayName = this.state.fridayName;
      res.fridayLocationId = this.state.selectedLocation.id;
      res.fridayDate = (this.state.fridayDate&&this.state.fridayDate.date)||null;
      if(res.reservationId){
        res.replacingReservationId = res.reservationId;
        createReservation(res)
          .then(res => {
              this.props.handleUpdateReservation(res);
              this.props.toggle();
              this.props.fridayCanContinue(true);
            }, error => {
              this.setState({
                error,
                isSubmitting: false,
              })
            });
      } else {
        this.props.handleUpdateReservation(res);
        this.props.toggle();
        this.props.fridayCanContinue(true);
      }
    }
  }

  render() {
    const { t, infoRequired, cancelLink, reservation, handleScreenChange } = this.props;
    const { error, locations, selectedLocation, fridayName, isLoadedSchedule, fridayDatesAvailable, fridayDate } = this.state;
      return locations&&isLoadedSchedule?
          <div className="col-12">
          {error?<Alert color="danger">{t(error)}</Alert>:null}
          {infoRequired&&!reservation.fridayLocationId?
            <Alert color="warning">{t("Please make sure to fill out all fields in order to be able to check in.")}</Alert>
          :null}
          <form autoComplete="off" onSubmit={this.handleSubmit} >
            {fridayDatesAvailable.length>1?
            <div className="form-group">
              <UncontrolledDropdown>
                <div className="mb-2">{t("Tevilah Date")}</div>
                <DropdownToggle caret className="btn-block">
                  {fridayDate!==null ? <><Moment format={t("dddd, MMMM D")} element="span">{fridayDate.date}</Moment> - <span>{fridayDate.hebrewDayHe} {fridayDate.hebrewMonthHe}</span></>: t("Select Date")}
                </DropdownToggle>
                <DropdownMenu>
                  {fridayDatesAvailable.map((day,i) => {
                    return <DropdownItem key={i} className={"" + (day===fridayDate?" active":"")} onClick={() => this.setState({fridayDate: day})}><Moment format={t("dddd, MMMM D")} element="span">{day.date}</Moment> - <span>{day.hebrewDayHe} {day.hebrewMonthHe}</span></DropdownItem>
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
            :null}
            <div className="form-group">
              <UncontrolledDropdown>
                <div className="mb-2">{t("Tevilah Location")}</div>
                <DropdownToggle caret className="btn-block">
                  {selectedLocation!==null ? (selectedLocation.name) : t("Select Location")}
                </DropdownToggle>
                <DropdownMenu>
                  {locations.map((location,i) => {
                    return <DropdownItem key={i} className={"dir-rtl" + (location===selectedLocation?" active":"")} onClick={() => this.setState({selectedLocation: location})}><span dir="ltr">{location.address}</span> - {location.area?location.area+" - ":''}{location.name}</DropdownItem>
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
            <div className="form-row">
              <div className="form-group col">
                <label htmlFor="feeDescription">{t("Your Name")}</label>
                <input className="form-control" id="name" value={fridayName} onChange={(e)=>this.setState({fridayName: e.target.value})} />
              </div>
            </div>
             <hr />
            <div className="text-center">
              <Button className="mx-auto btn-secondary" disabled={!fridayName||!selectedLocation||!(((fridayDatesAvailable.length>1&&fridayDate)||fridayDatesAvailable.length===1))} large>{t("Continue")}</Button>
              {infoRequired&&!reservation.fridayLocationId?
                <Link to={cancelLink?cancelLink:null} onClick={handleScreenChange?()=>handleScreenChange('welcome', { resetReservationCode: true }):null} className="d-block"><Button className="mt-3" type="outline-primary">{t("Cancel Check-In")}</Button></Link>
              :null}
            </div>
          </form>
        </div>
      :null
  }
}

export default withTranslation()(FridayLocation);